import React, { Component, Fragment } from 'react';
import { SEE_MORE_LESS_CHAR_LENGTH } from '../../utils/constants';
import PropTypes from 'prop-types';
import './read-more-less.css';

class ReadMoreLess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMore: false
    };
  }

  showMoreLess = (e) => {
    e.preventDefault();
    this.setState({ showMore: !this.state.showMore });
  };

  render() {
    const { showMore } = this.state;
    const characterLength = this.props.characterLength ? this.props.characterLength : null;
    return (
      this.props.content && (
        <Fragment>
          <p id={this.props.id} className={this.props.countryCode === 'IN' && 'see-more-less_P_IN'}>
            {showMore
              ? this.props.content
              : this.props.content.substring(
                  0,
                  characterLength ? characterLength : SEE_MORE_LESS_CHAR_LENGTH
                )}
            {!this.props.noButton && (
              <span
                className={this.props.countryCode === 'IN' ? 'see-more-less_IN' : 'see-more-less'}
                onClick={this.showMoreLess}
              >
                {' Read ' + (showMore ? 'less' : 'more')}
              </span>
            )}{' '}
          </p>
        </Fragment>
      )
    );
  }
}

ReadMoreLess.defaultProps = {
  id: ''
};

ReadMoreLess.propTypes = {
  content: PropTypes.string,
  characterLength: PropTypes.number,
  countryCode: PropTypes.string,
  id: PropTypes.string,
  noButton: PropTypes.any
};

export default ReadMoreLess;
